<template>

  <div class="memberAssociation">
    <iframe :src="iframeUrl" frameborder="0" class="iframeBox" style="width:100%"></iframe>
  </div>
</template>
<script>
import  memberAttachment from '@/views/Member/Member_sub/Member_constitution_sub/darenhui2020_1.vue'
export default {
  components:{
    'Member-Attachment':memberAttachment
  },
  data(){
    return {
      iframeUrl:null,
      devUrl:"https://newmtest.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0",
      devEnUrl:"https://newmtest.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0&lang=en",
      funUrl:"https://m8-fun.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0",
      funEnUrl:"https://m8-fun.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0&lang=en",
      proUrl:"https://m8.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0",
      proEnUrl:"https://m8.dominos.com.cn/extraPage/protocol.html?code=memberagreement&isShowHeader=0&lang=en",
    
    }

  },
   created(){
     console.log("this.$route",window.location.host)
     if(window.location.hostname == 'web8-dev.dominos.com.cn') {
     this.iframeUrl = localStorage.getItem("language") == 'en' ? this.devEnUrl : this.devUrl;
   }else if(window.location.hostname == 'web8-fun.dominos.com.cn') {
     this.iframeUrl = localStorage.getItem("language") == 'en' ? this.funEnUrl : this.funUrl;
   }else {
      this.iframeUrl = localStorage.getItem("language") == 'en' ? this.proEnUrl : this.proUrl;
   }
   }
}
</script>
<style lang="scss" scoped>
.iframeBox {
  height: calc(100vh - 400px);
}
@mixin memberFontSize($fontSize) {
  font-size: $fontSize;
}
.memberAssociation{
  text-align: left;
  width: 88%;
  margin:0 auto;
  white-space: normal;
  color:#000;
  padding-top: 20px;
  .headsection{
    p{
      padding-bottom:6px;
    }
  }
  .fontFamilyWingdings{
    font-size: 11pt;
     font-family: "Wingdings";
     
  }
  .textindent{
    text-indent:12px;
  }
  .textindentbig{
    text-indent:22px;
  }
  .marginTop10{
    margin-top:10px;
  }
  .member_oblique{
    font-style:oblique;
  } 
  .member_underline{
    text-decoration: underline;
  }
  .member_blackcolor{
    color:#000;
  }
   .member_fontweight400{
    font-weight: 400;
  }
  .member_fontweight{
    font-weight: 700;
  }
  .member_textaligncenter{
    text-align: center;
  }
  .member_fontsize20{
    @include memberFontSize(20px);
  }
  .member_fontsize19{
    @include memberFontSize(19px);
  }
  .member_fontsize18{
    @include memberFontSize(18px);
  }
  .member_fontsize16{
    @include memberFontSize(16px);
  }
   .member_fontsize14{
    @include memberFontSize(14px);
  }
  .paddingTop10Bottom10{
    padding:10px 0px;
  }
  .member_disflex{
    display: flex;
  }
  .member_flex1{
    flex:1;
  }
  .gradetable{
    .tableborder{
      border:1px solid #333;
      width: 100%;
      margin:10px 0px;
      th,td{
        border-right:1px solid #333;
        border-bottom:1px solid #333;
        padding:6px 10px;
      }
      .topalign{
        vertical-align: top;
      }
      .obline{
        border-top: 1px solid #000;
        transform: rotate(11deg);
      }
    }
     .tablecenter{
        text-align: center;
         th,td{
          padding:10px 0px;
          text-align: center
        }
      }
  }
  
}


</style>